import { Controller, useFormContext } from 'react-hook-form';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Input } from 'ui/input/Input';
import { AddGroupFormBody } from '../AddGroup.types';
import { GlcValueEnum } from '../AddGroup.enum';
import { OrganizationsTreeSelect } from 'ui/organizationsTreeSelect/OrganizationsTreeSelect';
import { Form } from 'ui/form/Form';
import { useAppSelectOptions } from 'hooks/useAppSelectOptions/useAppSelectOptions';

import * as Styled from './AddGroupDefinitionForm.styles';

export const AddGroupDefinitionForm = () => {
  const { formatMessage } = useLocale();

  const {
    register,
    control,
    formState: { errors },
    setValue,
  } = useFormContext<AddGroupFormBody>();

  const { groupTypeOptions, glcOptions } = useAppSelectOptions();

  const resetSelectedValues = () => {
    setValue('tkds', []);
    setValue('idGlcs', []);
  };

  return (
    <>
      <Input
        {...register('idGrupy')}
        required
        label={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.id.label'] })}
        placeholder={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.id.placeholder'] })}
        errorMessage={errors?.idGrupy?.message}
      />

      <Input
        {...register('nazwa')}
        required
        label={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.name.label'] })}
        placeholder={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.name.placeholder'] })}
        errorMessage={errors?.nazwa?.message}
      />

      <Form.ControlledSelect
        control={control}
        name="typ"
        required
        label={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.type.label'] })}
        withHelperText
        errorMessage={errors?.typ?.message}
        placeholder={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.type.placeholder'] })}
        testId="typeSelect"
        options={groupTypeOptions}
      />

      <Controller
        control={control}
        name="komorki"
        render={({ field }) => (
          <OrganizationsTreeSelect
            {...field}
            multiple
            placeholder={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.cell.placeholder'] })}
            label={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.cell.label'] })}
            inheritChildren
          />
        )}
      />

      <Form.ControlledSelect
        name="glc"
        control={control}
        onChange={(e) => {
          resetSelectedValues();
          setValue('glc', e.target.value as GlcValueEnum, { shouldDirty: true });
        }}
        label={formatMessage({ id: AppMessages['groups.addGroup.permissions.field.glc.label'] })}
        withHelperText
        testId="glcSelect"
        required
        options={glcOptions}
      />

      <Styled.DescriptionInputWrapper>
        <Input
          {...register('opis')}
          label={formatMessage({ id: AppMessages['groups.addGroup.groupDefinition.field.description.label'] })}
          placeholder={formatMessage({
            id: AppMessages['groups.addGroup.groupDefinition.field.description.placeholder'],
          })}
          errorMessage={errors?.opis?.message}
        />
      </Styled.DescriptionInputWrapper>
    </>
  );
};
